import {
  BulkValidSystemsResponseType,
  ConfigurationType,
  SystemCombinationType
} from 'data/types';
import {
  FailedValidSystemsSource,
  hasFailedValidSystemsSource
} from 'features/ui';
import { isConfigurationComplete } from 'utils/configuration-eligibility';

export function getExpectedFullFetchConfigIds(
  configurations: ConfigurationType[],
  leftoverSpaceIds?: ReadonlySet<string>
): string[] {
  return configurations
    .filter((configuration) =>
      isConfigurationComplete(configuration, leftoverSpaceIds)
    )
    .map((configuration) => configuration.uniqueId);
}

export function areExpectedFullFetchesSettled(options: {
  expectedConfigIds: string[];
  systemCombinationsFull: Record<string, SystemCombinationType[]>;
  failedValidSystemsConfigSources: Record<string, FailedValidSystemsSource[]>;
}): boolean {
  const {
    expectedConfigIds,
    systemCombinationsFull,
    failedValidSystemsConfigSources
  } = options;
  return expectedConfigIds.every(
    (id) =>
      Object.prototype.hasOwnProperty.call(systemCombinationsFull, id) ||
      hasFailedValidSystemsSource(failedValidSystemsConfigSources, id, 'full')
  );
}

export function isScoringDegradedResponse(
  response: BulkValidSystemsResponseType
): boolean {
  return (
    response.scenarios.length === 0 &&
    response.combinations.length === 0 &&
    response.perCondenser.some(
      (perCondenser) => perCondenser.systems.length > 0
    )
  );
}
